import { render, staticRenderFns } from "./OrderService.vue?vue&type=template&id=070a63b5&scoped=true"
import script from "./OrderService.vue?vue&type=script&lang=js"
export * from "./OrderService.vue?vue&type=script&lang=js"
import style0 from "./OrderService.vue?vue&type=style&index=0&id=070a63b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070a63b5",
  null
  
)

export default component.exports